<template>
	<div class="track-desc">
		<img src="@/assets/Stockholms_Basta_logo_portrait_pos.png" />
		<div class="texts-div">
			<h1 v-if="title">{{title.toUpperCase()}}</h1>
			<p v-if="subTitle">{{subTitle.toUpperCase()}}</p>
		</div>
	</div>
</template>

<script>
export default {


props: {
	title: String,
	subTitle: String,
}

}
</script>

<style scoped>

@media (max-width: 550px), (max-height: 500px) {
	body .track-desc {
		font-size: .7em;
	}

	.track-desc img {
		width: 35px;
	}
}	

	.track-desc {
		pointer-events: none;
		/* background-color: #ff000044; */
		position: absolute;
		top: 2em;
		left: 16px;
		right: 40px;
		z-index: 10000000;
		display: flex;
		flex-flow: row nowrap;
		align-items: center;
	}

	.texts-div {
		/* background-color: #00ff0044; */

		align-self: stretch;

		display: flex;
		flex-flow: column nowrap;
		justify-content	: center;

		padding-top: 3px;
		padding-bottom: 3px;
		padding-left: .8em;
		border-left: solid 1px black;
	}

	img {
		/* margin-top: 12px; */
		width: 50px;
		margin-top: -1.5em;
		margin-bottom: -2px;
		margin-right: .8em;
	}

	h1 {
		color: var(--brand-color-dark);
		margin-top: 0;
		margin-bottom: 10px;
		font-size: 2em;
		line-height: 1em;
	}

	p {
		margin-top: -10px;
		margin-bottom: 0;
		font-weight: 700;
	}
</style>